export default {
  apiContactFormPostinId: '39a001a0-743f-4fcc-921e-155eb30bfe4f',
  searchPlaceholder: 'Recherche de nos produits...',
  searchPlaceholderProducts: 'Rechercher un produit...',
  yourData: 'Vos données:',
  name: 'Nom*',
  surname: 'Prénom*',
  email: 'Email*',
  phone: 'Téléphone*',
  city: 'Ville*',
  role: 'Tâche',
  requestType: 'Type de demande',
  company: 'Agence',
  message: 'Message',
  termsExtLabel:
    "J'accepte le traitement de mes données personnelles comme indiqué dans la politique de confidentialité et de recevoir par email ou téléphone les informations demandées via ce formulaire.",
  newsletterExtLabel:
    "Je souhaite m'inscrire à la newsletter pour rester informé des nouveautés de Bioenologia (vous pourrez vous désinscrire à tout moment via le lien présent dans chaque newsletter que vous recevrez)",
  termsError: 'Veuillez accepter les termes et conditions',
  sendRequest: 'Envoyer la demande',
  requests: 'Commerciale,Soutien,Autre',
  roles: 'Titulaire,Vigneron,Responsable de production',
  success: 'Demande envoyée avec succès',
  error: "Une erreur s'est produite",
  endMessage:
    'Bioenologia utilisera les données personnelles uniquement pour fournir les services demandés et ne les cédera pas à des tiers à des fins publicitaires. Vous pouvez demander la suppression de vos données de nos systèmes à tout moment via ce formulaire.',

  // Product contact
  productContact: 'Demander des informations<br> sur le produit',
  forProduct: 'Produit sélectionné:',
  forProducts: 'Produits sélectionnés:',
  otherProducts: "Voulez-vous ajouter d'autres produits à votre demande?",
  otherProductsText:
    "Sélectionnez-les dans la liste ou recherchez-les à l'aide du champ de recherche ci-dessous.",
}
